import React from "react";
import {Form} from "react-bootstrap";

export function AGCTextArea({
                                formik,
                                name,
                                toolTip,
                                id,
                                placeHolder,
                                value,
                                rows = 5,
                                forUpdate = false,
                                required = true,
                                showToolTip = true,
                            }) {
    if (toolTip === "") {
        toolTip = "Enter the " + name;
    }

    if (placeHolder === "") {
        placeHolder = "Enter the " + name;
    }

    if (value === null) {
        value = ""
    }

    return (
        <>
            <Form.Label className={required ? "required" : ""}>{name}</Form.Label>
            <Form.Control
                as="textarea"
                id={id}
                placeholder={placeHolder}
                onChange={formik.handleChange}
                value={value}
                rows={rows}
                disabled={forUpdate}
            />
            {showToolTip && <Form.Text className="text-muted">{toolTip}</Form.Text>}
        </>
    );
}
